module.exports = __webpack_public_path__ + "img/moon.1edb7150.svg";